import { render, staticRenderFns } from "./StudentPoliciesSave.vue?vue&type=template&id=8dc53f90&"
import script from "./StudentPoliciesSave.vue?vue&type=script&lang=js&"
export * from "./StudentPoliciesSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports